import { useContext } from 'react';
import EditVersionContext from '@/context/EditVersionContext/EditVersionContext.tsx';
import { EditVersionContextType } from '@/context/EditVersionContext/types.ts';

export const useEditVersionContext = (): EditVersionContextType => {
  const context = useContext(EditVersionContext);
  if (!context) {
    throw new Error('useEditVersionContext must be used within an EditVersionProvider');
  }
  return context;
};

/** Read the editor's version-pinned schema snapshot without issuing a query. */
export const useEditingVersionSnapshot = () => useContext(EditVersionContext)?.editingVersion ?? null;
